import React from "react";
import { PermissionWrapper, Dropdown } from "components";

// Підкомпонент комірки "Категорія"
const CategoryCell = ({
  item,
  editing,
  setEditing,
  handleUpdate,
  handleKeyDown,
  mappedCategories,
}) => (
  <PermissionWrapper
    requiredPermission="traps:edit"
    fallback={
      <td>
        <span>{item.trap_category_name || "---"}</span>
        {item.crm_category_name && (
          <span className="badge" title="Категорія в CRM">
            {item.crm_category_name}
          </span>
        )}
      </td>
    }
  >
    <td onDoubleClick={() => setEditing({ field: "category_id", value: "" })}>
      {editing.field === "category_id" ? (
        <Dropdown
          options={mappedCategories}
          selected={parseInt(editing.value, 10)}
          onChange={(selectedId) => handleUpdate("category_id", selectedId)}
          onKeyDown={handleKeyDown}
          mode="autocomplete"
          placeholder="Пошук або вибір категорії..."
          autoFocus
        />
      ) : (
        <>
          <span>{item.trap_category_name || "---"}</span>
          {item.crm_category_name && (
            <span className="badge" title="Категорія в CRM">
              {item.crm_category_name}
            </span>
          )}
        </>
      )}
    </td>
  </PermissionWrapper>
);

export default CategoryCell;